import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const CorruptionSectionContainer = styled.section(({ theme }) => ({
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const CorruptionSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",

  button: {
    width: "100%",

    [theme.breakpoint.lg()]: {
      width: "fit-content",
    },
  },
}));

export const CorruptionSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const CorruptionSectionDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));
